import yandexMapsService from './yandexMapsService.js';
const moduleName = 'yandexMaps';
angular.module(moduleName, []).service('yandexMapsService', yandexMapsService);
export default moduleName;